import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

type NoSearchResultsInfoProps = ComponentProps<'p'>;

export const NoSearchResultsInfo = memo(({ className, ...props }: NoSearchResultsInfoProps) => (
  <p className={cn('text-14 text-grey-11', className)} {...props} />
));

NoSearchResultsInfo.displayName = 'NoSearchResultsInfo';
